import React from 'react';
import { Section, BOOK_COVER } from './ui';
import { CheckCircle2, BookOpen, BarChart3, Shield, Crosshair, ListChecks } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <BookOpen className="w-8 h-8 text-brand-500" data-id="element-126" />,
    title: 'Backtesting sin adivinar',
    desc: 'Siguiendo un paso a paso claro para saber qué buscar, qué medir y qué descartar.'
  }, {
    icon: <ListChecks className="w-8 h-8 text-brand-500" data-id="element-127" />,
    title: 'Reglas objetivas',
    desc: "Convertí tu estrategia en reglas para dejar de operar según lo que 'sentís' y empezar a tomar decisiones con un plan."
  }, {
    icon: <Crosshair className="w-8 h-8 text-brand-500" data-id="element-128" />,
    title: 'Detectar operaciones válidas',
    desc: 'Sabé si una operación fue válida o forzada, para no confundirte entre una pérdida normal y un error de ejecución.'
  }, {
    icon: <Shield className="w-8 h-8 text-brand-500" data-id="element-129" />,
    title: 'Claridad y confianza',
    desc: 'Llegá al mercado real con datos que respalden tu forma de operar antes de arriesgar dinero.'
  }];
  return <Section darker data-id="element-130">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-131">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-132">
          Lo que vas a lograr con La Biblia del Backtest
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-133">
        {benefits.map((benefit, idx) => <div key={idx} className="bg-dark-card border border-dark-border p-8 rounded-2xl hover:border-brand-500/50 transition-all duration-300 group" data-id="element-134">
            <div className="w-16 h-16 rounded-xl bg-brand-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-135">
              {benefit.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-white mb-3" data-id="element-136">
              {benefit.title}
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-137">{benefit.desc}</p>
          </div>)}
      </div>
    </Section>;
}
export function ProductBreakdown() {
  const modules = [{
    title: 'La raíz del problema',
    desc: 'Por qué operás con dudas, qué pasa cuando no tenés datos y cómo la emoción empieza a tomar decisiones por vos.'
  }, {
    title: 'Backtesting paso a paso',
    desc: 'Cómo testear una estrategia de forma clara, objetiva y ordenada sin mirar gráficos al azar.'
  }, {
    title: 'Sistema de reglas',
    desc: 'Cómo definir cuándo entrar, cuándo salir, cuándo esperar y cuándo directamente no operar.'
  }, {
    title: 'Recolección y lectura de datos',
    desc: 'Qué registrar, cómo medir tu estrategia y cómo detectar tus mejores setups, horarios y errores repetidos.'
  }, {
    title: 'Psicología del trader',
    desc: 'Cómo reconocer miedo, ansiedad, FOMO y revancha para que no contaminen tu ejecución.'
  }, {
    title: 'Plan de ejecución',
    desc: 'Una rutina práctica para aplicar antes, durante y después de operar, y llevar tu estrategia al mercado real.'
  }];
  return <Section data-id="element-138">
      <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-139">
        <div className="lg:col-span-5 sticky top-24" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-141">
            ¿Qué hay dentro del ebook?
          </h2>
          <p className="text-lg text-gray-400 mb-8" data-id="element-142">
            Un temario diseñado para llevarte desde la confusión total hasta
            tener un sistema validado y listo para ejecutar.
          </p>

          <div className="relative flex items-center justify-center" data-id="element-143">
            <div className="absolute -inset-4 bg-brand-500/15 blur-3xl rounded-full pointer-events-none" data-id="element-144"></div>
            <img src={BOOK_COVER} alt="Portada del ebook La Biblia del Backtest" className="relative w-full max-w-[300px] rounded-xl shadow-2xl border border-brand-500/20" data-id="element-145" />
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-146">
          <div className="space-y-4" data-id="element-147">
            {modules.map((mod, idx) => <div key={idx} className="bg-dark-card border border-dark-border p-6 rounded-xl flex gap-4" data-id="element-148">
                <div className="flex-shrink-0 mt-1" data-id="element-149">
                  <CheckCircle2 className="w-6 h-6 text-brand-500" data-id="element-150" />
                </div>
                <div data-id="element-151">
                  <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-152">
                    {mod.title}
                  </h3>
                  <p className="text-gray-400" data-id="element-153">{mod.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}
export function Bonuses() {
  return <Section darker data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <span className="inline-block py-1 px-3 rounded-full bg-amber-500/20 text-amber-500 font-bold text-sm mb-4 border border-amber-500/30" data-id="element-157">
            BONUS EXCLUSIVO
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-158">
            Llevate también esta guía de acción rápida
          </h2>
        </div>

        <div className="bg-gradient-to-br from-dark-card to-dark-bg border border-brand-500/30 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-159">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-160"></div>

          <div className="grid md:grid-cols-3 gap-8 items-center relative z-10" data-id="element-161">
            <div className="md:col-span-1" data-id="element-162">
              <div className="aspect-square bg-dark-border rounded-xl flex items-center justify-center border border-dark-border shadow-inner" data-id="element-163">
                <BarChart3 className="w-20 h-20 text-brand-500 opacity-80" data-id="element-164" />
              </div>
            </div>

            <div className="md:col-span-2" data-id="element-165">
              <h3 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-166">
                Plan de 7 Días de Backtesting
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-167">
                Una guía práctica para empezar a aplicar el backtesting sin
                abrumarte. Durante 7 días vas a saber qué hacer paso a paso:
                definir tu estrategia, crear tus reglas, preparar tu plantilla,
                registrar tus primeras operaciones y leer tus primeros datos
                para detectar patrones, errores y oportunidades de mejora.
              </p>
              <div className="inline-flex items-center gap-2 text-brand-400 font-semibold" data-id="element-168">
                <CheckCircle2 className="w-5 h-5" data-id="element-169" />
                Incluido GRATIS con tu compra hoy
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}